import React, { useState, useEffect } from 'react';
import { navigationData } from '../data/mock';
import { Menu, X } from 'lucide-react';

const LINKEDIN_URL = 'https://www.linkedin.com/in/santanudsharma/';

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled || isMobileMenuOpen
          ? 'bg-[#0f1a2a]/95 backdrop-blur-xl border-b border-[#2a3a4d]'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#"
            className={`font-serif text-lg transition-all duration-500 ${
              isScrolled ? 'text-[#f5f5f0]' : 'text-[#333333]'
            } hover:opacity-80`}
          >
            {navigationData.logo}
          </a>

          {/* Desktop Navigation */}
          <ul className="hidden lg:flex items-center gap-8">
            {navigationData.links.map((link, index) => (
              <li key={index}>
                <a
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className={`nav-link text-sm transition-all duration-300 relative ${
                    isScrolled ? 'text-[#b8c5d4] hover:text-[#f5f5f0]' : 'text-[#333333] hover:text-[#000000]'
                  }`}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          {/* Desktop CTA - LinkedIn */}
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={`hidden lg:inline-flex items-center justify-center px-6 py-3 text-sm font-medium transition-all duration-300 relative overflow-hidden group ${
              isScrolled 
                ? 'text-[#f5f5f0] border border-[#5a7fa8]/40 hover:border-[#c9a87c] hover:text-[#c9a87c]' 
                : 'text-[#333333] border border-[#333333] hover:bg-[#333333] hover:text-[#fffef2]'
            }`}
          >
            <span className="relative z-10">{navigationData.cta}</span>
          </a>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 transition-colors duration-300 ${
              isScrolled || isMobileMenuOpen ? 'text-[#f5f5f0]' : 'text-[#333333]'
            }`}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-6 border-t border-[#2a3a4d] bg-[#0f1a2a]">
            <ul className="flex flex-col gap-4">
              {navigationData.links.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="block py-2 text-base text-[#b8c5d4] hover:text-[#f5f5f0] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={LINKEDIN_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center px-6 py-3 mt-4 text-sm font-medium text-[#f5f5f0] border border-[#5a7fa8]/40 hover:border-[#c9a87c] hover:text-[#c9a87c] transition-all duration-300"
                >
                  {navigationData.cta}
                </a>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
};
